export default __webpack_public_path__ + "img/pass-off.ca378155.svg";